<div class="h-100">
  <div class="home-page-backgound-content">
    <div class="home-page-content">
      <h1 class="heading">Bring local Farms to your door</h1>
      <p class="supporting-text">✔Convenient&nbsp;  &nbsp;✔Transparent  &nbsp;&nbsp;✔Local</p>
      <div class="button-group">
        <a routerLink="/sign-up" class="home-button">Learn More</a>
      </div>
    </div>
  </div>
</div>
<div>
  <section class="howItWorksSection">
    <h2 class="howItWorksHeading">Shop Local Food When You Join Little Farm Association</h2>
    <div class="howItWorksContent">
      <div class="howItWorksStep">
        <div class="howItWorksDiv">
          <div class="howItWorksStepHeader">
              <span class="bullet">1</span> Become an LFA Member
          </div>
          <p>Make buying local EASY with our unique online platform where members get access to 40 + farmers, food crafters, and home goods artisans.  LFA brings the farmer's market right to your fingertips. Join our Priviate Members' Association to get access to great food and easy home delivery.</p>
        </div>
      </div>
      <div class="howItWorksStep">
        <div class="howItWorksDiv">
          <div class="howItWorksStepHeader">
              <span class="bullet">2</span> Support Your Health and Local Businesses
          </div>
          <p>Choose the items you need in the quantities you want. You choose what goes in your cart AND how often you receive deliveries.  Choose from more than 500 items from many different farms. Get your food at its peak freshness and know exactly how it was grown or raised. Choose the local businesses you want to support with your food purchases.</p>
        </div>
      </div>
      <div class="howItWorksStep">
        <div class="howItWorksDiv">
          <div class="howItWorksStepHeader">
              <span class="bullet">3</span> Enjoy the fruits of your labor
          </div>
          <p>After you order, your items will be collected directly from the producers and delivered in an insulated carrier to your home or office.  LFA has done all the hard work for you. Enjoy clean, healthy grocery items and be part of vibrant community of like-minded folks just like you.</p>
        </div>
      </div>
    </div>
    <div>
      <div class="howItWorksButtonDiv">
        <button class="howItWorksButton" routerLink="/shop">Join now</button>
      </div>
    </div>
  </section>
</div>
<!-- <div class="divider-div">
  <hr>
</div> -->
<div class="photoGridWidgetDiv">
  <section class="photoGridWidget">
    <div class="photoGridHeading">
      <h2>What is available locally?</h2>
    </div>
    <app-category-grid [items]="categories"></app-category-grid>
  </section>
</div>
<!-- <div class="divider-div">
  <hr>
</div> -->
<div class="WhereWeDeliverMainDiv">
  <div class="WhereWeDeliverDiv">
    <div class="WhereWeDeliverInnerDiv">
        <h1 class="WhereWeDeliverHeading">See where we deliver</h1>
        <div class="WhereWeDeliverSubHeading">
          <br>
          And where we would like to expand our service to
        </div>
        <div class="WhereWeDeliverButtonDiv">
          <button class="WhereWeDeliverButton">Learn More</button>
        </div>
    </div>
  </div>
</div>

<!-- <div class="divider-div">
  <hr>
</div> -->
<div class="OutsideDeliveryAreaMainDiv">
  <div class="OutsideDeliveryAreaDiv">
    <div class="OutsideDeliveryAreaInnerDiv">
        <h1 class="OutsideDeliveryAreaHeading">Are you outside our delivery area? <br></h1>
        <div class="OutsideDeliveryAreaSubHeading">
          We are growing continuously! We expand new delivery routes when we receive enough interest for a particular area.   <br>Fill out this form and we will try to get a drop point or delivery route to your area! <br>If you get a few friends or neighbors to fill it out, too, we will get there even sooner!
        </div>
        <div class="OutsideDeliveryAreaButtonDiv">
          <button class="OutsideDeliveryAreaButton">I am Interested! Put me on the Waiting List!</button>
        </div>
    </div>
  </div>
</div>
<!-- <div class="divider-div">
  <hr>
</div> -->
<div class="MeetOurFarmersMainDiv">
  <div class="MeetOurFarmersDiv" style="background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(assets/little-farm/files/images/3/content-images/Meetthefarmers.jpg); background-size: cover; background-position: top;">
    <div class="MeetOurFarmersInnerDiv">
      <h2 class="MeetOurFarmersHeading">Meet the Farmers</h2>
      <div class="MeetOurFarmersSubHeading">
        <p>More and more people are wanting to know where their food comes from and the practices of the farmers who grow it. When you choose the Little Farm Association, you know you are supporting local farmers and you can see their agricultural methods.</p>
        <br>
        <p style="display: flex; align-items: center; justify-content: center; gap: 8px;">
          <mat-icon>monetization_on</mat-icon>
          Did you know that according to the national farmers union for every dollar spent on food in the USA only 14% actually goes to the farmer?!
        </p>
        <br>
        <p style="display: flex; align-items: center; justify-content: center; gap: 8px;">
          <mat-icon>local_shipping</mat-icon>
          Also, It's estimated that the average plate of food travels more than 1500 miles!
        </p>
        <br>
        <p style="display: flex; align-items: center; justify-content: center; gap: 8px;">
          <mat-icon>eco</mat-icon>
          When you buy food through LFA, at least 50% of your final price goes directly to the farm which grows it! Buying local foods maximizes your food's nutritional benefits while strengthening our local economy!
        </p>
      </div>
      <div class="MeetOurFarmersButtonDiv">
        <button class="MeetOurFarmersButton" routerLink="/producers">See Producer Profiles</button>
      </div>
    </div>
  </div>
</div>
<div class="divider-div">
  <hr>
</div>
<div class="WantToSellProductsMainDiv">
  <div class="WantToSellProductsDiv" style="background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(assets/little-farm/files/images/3/content-images/Haveproductstosell.jpg); background-size: cover; background-position: center;">
    <div class="WantToSellProductsInnerDiv">
      <h1 class="WantToSellProductsHeading">Have products to sell?</h1>
      <div class="WantToSellProductsSubHeading">
        <br>We are actively connecting many more farms into this network for the 2024 growing season. <br>It takes many small farms to build a regional food system and we could use your help!<br>
      </div>
      <div class="WantToSellProductsButtonDiv">
        <a class="WantToSellProductsButton" href="https://app.flowtrack.co/form/dk9pes" target="_blank">Find out how!</a>
      </div>
    </div>
  </div>
</div>